import DarkFrameworkImages from '@vfgroup-oneplatform/framework/Themes/Modes/Dark/Images'

import images from '../../Images'

const Images = {
  ...DarkFrameworkImages,
  ...images,
  two_slots: images.two_slots_white,
  three_slots: images.three_slots_white,
  four_slots: images.four_slots_white,
  members: images.members_white,
  offer: images.offer_white,
  plan_internet: images.plan_internet_white,
  plan_messages: images.plan_messages_white,
  plan_minutes: images.plan_minutes_white,
  tv: images.tv_white,
  plan: images.plan_white,
  id_icon: images.id_icon_white,
  download: images.download_white,
  mobile: images.mobile_white
}

export default Images
